module.exports = __webpack_public_path__ + "static/media/radio-classique-logo.beb7e074.png";